module.exports = __webpack_public_path__ + "Gotham-Book.21cc311563a10eb42508.eot";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Book.eot
// module id = ../../../../../src/assets/fonts/Gotham-Book.eot
// module chunks = 2